import { updateUser } from "@/services/api";
import { useCurrentUser } from "@/services/hooks";
import { Box, Skeleton, TextField } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import debounce from "lodash/debounce";
import { useCallback, useEffect, useState } from "react";
import AlertSnackbar from "@/components/AlertSnackbar";
export default function Display() {
  const { data: currentUser, isLoading } = useCurrentUser();
  const queryClient = useQueryClient();

  const [value, setValue] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);

  // Update state when currentUser data is loaded
  useEffect(() => {
    if (currentUser) {
      setValue(currentUser.name || "");
    }
  }, [currentUser]);

  const mutation = useMutation({
    mutationFn: () => updateUser(value, {}),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["current_user"] });
      setShowSnackbar(true);
    },
  });

  const debouncedSave = useCallback(
    debounce((newValue) => {
      mutation.mutate();
    }, 1000),
    []
  );

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    debouncedSave(newValue);
  };

  if (isLoading) {
    return (
      <Skeleton
        variant="rectangular"
        height={56}
        width="100%"
        sx={{ my: 2, borderRadius: "25px" }}
      />
    );
  }

  return (
    <Box sx={{ pt: 1, width: "100%" }}>
      <AlertSnackbar
        showSnackbar={showSnackbar}
        setShowSnackbar={setShowSnackbar}
      />
      <TextField
        label="Name"
        variant="outlined"
        value={value}
        required
        fullWidth
        onChange={handleChange}
        disabled={mutation.isPending}
      />
    </Box>
  );
}
